import "./Button.scss";

const Button = ({
  label,
  type,
  onClick,
  isSecondary,
  isTertiary,
  name,
  Icon,
  isLabelRight,
  isDisabled = false,
}) => {
  let className = "button";
  if (isSecondary && !isTertiary) {
    className += " button--secondary";
  }
  if (isTertiary && !isSecondary) {
    className += " button--tertiary";
  }

  return (
    <button
      className={className}
      onClick={onClick}
      type={type}
      name={name}
      disabled={isDisabled}
    >
      {isLabelRight && label}
      {Icon && (
        <div className="button__icon">
          <Icon />
        </div>
      )}
      {!isLabelRight && label}
    </button>
  );
};

export default Button;
